import * as React from 'react';

export const TokenTransparencyHeader = () => {
    return (
        <div className="flex flex-col gap-4 border-b px-4 py-8 md:p-8 lg:p-10 ">
            <div className="flex justify-between items-end self-stretch">
                <div className="flex flex-col justify-start items-start relative gap-3">
                    <p className="font-semibold text-2xl lg:text-3xl xl:text-4xl text-left text-gray-900">
                        Token Transparency
                    </p>
                    <div className="flex justify-start items-start self-stretch relative gap-2.5">
                        <p className="text-left">
                            A standardized, open-source disclosure framework by Blockworks helping crypto projects earn
                            trust and signal transparency.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
